import React from 'react';
import {
	Row,
	Col,
	CardHeader,
	Card
}            from 'reactstrap';
import CardBody
			 from 'reactstrap/es/CardBody';

class TrackerNav extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			selectedID: null
		}
	}

	_onClick = (config) => {
		this.setState({selectedID: config.ID});
		if (this.props.onClickHandler && config.ID) {
			this.props.onClickHandler(config.ID)
		}
	}

	render() {
		return (
			<>
				<Card>
					<CardHeader>
					<h4>Configurations</h4>
					</CardHeader>
					<CardBody>
						<Row>
							{this.props.config && this.props.config.map(c => {
								var classes = this.state.selectedID === c.ID ? 'tracker-nav--selected' : '';
								return (
									<Col xs={12} sm={4} md={3} key={c.ID} className={`tracker-nav--config--title`} onClick={() => this._onClick(c)}>
										<div className={classes}>{c.Name}</div>
									</Col>
								)
							})}
						</Row>
					</CardBody>
				</Card>
			</>
		)
	}
}

export default TrackerNav;
